import moment from 'moment';
import { GET_USER_FEEDS, UPDATE_DATE_FILTER, UPDATE_WALL_AND_FEED, UPDATE_SELECTED_FEED, UPDATE_POST_TYPE,START_FEEDS_LOADER, UPDATE_WALL_FEED } from '../keys'
const initialState = { userfeeds: [], selectedWallFeed: [], dateFilter: { startDate: moment().subtract(29, 'days').startOf('day'), endDate: moment().endOf('day') }, selectedFeed: [],postType:[{ value: "1", label: "Public" }, { value: "2", label: "Private" }],loading:true }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_USER_FEEDS: {
            const { data, selectedData } = action.payload;

            let updateFeedList = [];
            if (selectedData && Object.keys(selectedData).length > 0) {
                if (selectedData && selectedData.feeds.length > 0) {
                    selectedData.feeds.map((item) => {
                        updateFeedList.push({ value: item.id, label: item.name })
                    })
                }
            }
            return { ...state, userfeeds: data, selectedWallFeed: selectedData, selectedFeed: updateFeedList,loading:false }
        }
        case UPDATE_WALL_FEED: {
            const { data } = action.payload;
            return { ...state, userfeeds: data }
        }
        case UPDATE_WALL_AND_FEED: {
            let updateFeedList = [];
            if (action.payload && Object.keys(action.payload).length > 0) {
                if (action.payload && action.payload.feeds.length > 0) {
                    action.payload.feeds.map((item) => {
                        updateFeedList.push({ value: item.id, label: item.name })
                    })

                }
            }
            return { ...state, selectedWallFeed: action.payload, selectedFeed: updateFeedList }
        }
        case UPDATE_DATE_FILTER: {
            return { ...state, dateFilter: action.payload }
        }
        case UPDATE_SELECTED_FEED: {
            return { ...state, selectedFeed: action.payload }
        }
        case UPDATE_POST_TYPE: {
            return { ...state, postType: action.payload }
        }

        case START_FEEDS_LOADER:{
            return {...state,loading:true};
        }

        default:
            return { ...state }
    }

}